import React, { FunctionComponent, ReactNode } from "react";
import { ReactComponent as IconClose } from "../../../../icons/x.svg";
import "./style.scss";

interface Props {
  children: ReactNode;
  onClick: () => void;
}

const PanelClosing: FunctionComponent<Props> = ({ children, onClick }) => {
  return (
    <div className="PanelClosing">
      <div className="PanelClosing-button" onClick={onClick}>
        <IconClose />
      </div>
      <div className="PanelClosing-title">{children}</div>
    </div>
  );
};

export default PanelClosing;
